import { StakingInfoResponse } from "models/staking-liquidity/StakingInfoResponse";
import { PoolResponse } from "models/staking/PoolResponse";
import { useEffect, useState } from "react";
import { LIQUIDITY_STAKING_ADDRESS } from "utils/Constants";
import { querySmartContract } from "utils/RpcHelpers";
import { TokenItem } from "./TokenItem";

export function LiquidityStakingDashboardPage() {
    const [stakingInfo, setStakingInfo] = useState<StakingInfoResponse>();
    const [poolInfo, setPoolInfo] = useState<PoolResponse>();
    const [dummyApr, setDummyApr] = useState<number>(0);

    const loadStakingInfo = async () => {
        const stakingInfo = await querySmartContract(LIQUIDITY_STAKING_ADDRESS, { staking_info: {} })
        setStakingInfo(stakingInfo)
    }

    const loadPoolInfo = async () => {
        const poolInfo = await querySmartContract(LIQUIDITY_STAKING_ADDRESS, { pool: {} })
        setPoolInfo(poolInfo)
    }



    const loadDummyApr = async () => {
        const config = await querySmartContract(LIQUIDITY_STAKING_ADDRESS, { dummy_apr: {} })
        setDummyApr(Number(config.dummy_apr))
    }

    useEffect(() => {
        loadStakingInfo()
        loadPoolInfo()
        loadDummyApr()
    }, [])

    return <div className="container-fluid container-p-y">
        <div className="row">
            <div className="col-12 col-md-6">
                <div className="card">
                    <div className="card-header d-flex align-items-center justify-content-between pb-0">
                        <div className="card-title mb-0">
                            <h5 className="m-0">Available Hybrid Staking Pools</h5>
                            <small className="text-muted">Select the pool you want to stake</small>
                        </div>
                    </div>
                    <div className="card-body">
                        <ul className="p-0 m-0">
                            {
                                (poolInfo && stakingInfo) && <TokenItem
                                    tokenAddress={stakingInfo.config.token_contract}
                                    pool={Number(poolInfo.pool.total_pool)}
                                    validatorAddress={stakingInfo.config.validator_address}
                                    tokenInfo={stakingInfo.token_info}
                                    isVerified={true}
                                    dummyApr={dummyApr}
                                />
                            }
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
}